import Auth from '@aws-amplify/auth';
import { AUTH_FLOW_TYPE } from './constants';

/**
 * (Re)configure aws auth. e.g. Setting up user pool, client id, etc
 *
 * @param  {object} authOptions - AWS Amplify-compliant config options
 * @param {string} authOptions.region - Cognito Region code
 * @param {string} authOptions.userPoolId - Cognito user pool ID
 * @param {string} authOptions.userPoolWebClientId - Cognito client ID
 */
export const configureAuth = (authOptions = {}) => {
  const {
    region = '',
    userPoolId = '',
    userPoolWebClientId = '',
    authenticationFlowType = AUTH_FLOW_TYPE,
  } = authOptions;

  Auth.configure({
    region,
    userPoolId,
    userPoolWebClientId,
    authenticationFlowType,
  });
};

export default Auth;
